<template>
  <Layout>
    <div class="row mb-5">
      <div class="col-md-6 mt-5 registration-left">
        <div class="row">
          <div class="col-md-4 offset-md-2">
            <img src="@/assets/images/man-1.png" alt="Man" height="203" width="190">
          </div>
          <div class="col-md-6">
            <p class="font-title">
              {{$t("paycheck_protection_program")}}
            </p>
            <p class="font-sub-title">
              {{$t("loan_company_lookup_search_tool")}}
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-10 offset-md-2">
            <p class="font-text mt-4">
              {{$t("the_ppp_epidemic")}}
            </p>

            <p class="mt-5 font-text mb-0">
              {{$t("easy_and_hassle_free_registration")}}
            </p>
            <p class="join-now pt-0">
              {{$t("join_now")}}
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-6 registration-right pb-4">
        <div class="row">
          <div class="col-md-10">
            <div class="registration-form">
              <p class="welcome">{{$t("welcome")}}</p>
              <p class="create-your-account">{{$t("create_your_account_with_us")}}</p>
              <img class="middle-line-logo" src="@/assets/images/middle_line_logo.png" alt="Loan"/>
              <div style="padding: 0 6%">
                <EmailBtn/>
                <FacebookBtn/>
                <GoogleBtn/>
              </div>

              <div class="link-sign-in text-center mt-4">
                <RouterLink to="/login">
                  <span class="existing-user">{{$t("existing_user")}} </span>
                  <span class="red-color">{{$t("sign_in")}}</span>
                </RouterLink>
              </div>
              <PrivacyTerms class="mt-5"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/layouts/main";
import GoogleBtn from "@/components/social/btn-google";
import EmailBtn from "@/components/social/btn-email";
import FacebookBtn from "@/components/social/btn-facebook";
import PrivacyTerms from "@/components/privacy-terms";
export default {
  name: "registration",
  components: {
    EmailBtn,
    Layout,
    GoogleBtn,
    FacebookBtn,
    PrivacyTerms
  },
  data() {
    return {};
  },
  mounted() {
    document.documentElement.setAttribute("data-layout", "horizontal");
    document.documentElement.setAttribute("data-layout-width", "fluid");
    document.documentElement.setAttribute("data-topbar", "dark");
    document.documentElement.setAttribute("data-sidebar-size", "sm");
    document.documentElement.setAttribute("data-layout-position", "fixed"); //scrollable
  },
  computed: {}
}
</script>

<style scoped>

</style>